import * as React from 'react';

import type { IconProps } from './types';

export const H2 = React.forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="18"
    height="13"
    viewBox="0 0 18 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <g clipPath="url(#clip0_300_1668)">
      <path
        d="M8.83333 0.472656C8.39474 0.472656 7.95614 0.508424 7.53509 0.579959V5.01513H3.11403V0.579959C2.64035 0.508424 2.20175 0.472656 1.76316 0.472656C1.32456 0.472656 0.903509 0.508424 0.5 0.579959V12.0434C0.95614 12.115 1.37719 12.1507 1.81579 12.1507C2.25439 12.1507 2.69298 12.115 3.11403 12.0434V7.4652H7.53509V12.0434C8.00877 12.115 8.44737 12.1507 8.88596 12.1507C9.32456 12.1507 9.74561 12.115 10.1667 12.0434V0.579959C9.69298 0.508424 9.27193 0.472656 8.83333 0.472656Z"
        fill={color}
      />
      <path
        d="M17.3854 10.4731L14.6593 10.4851L14.2934 10.5212L14.6003 10.3047C16.1462 9.0295 17.1376 7.88664 17.1376 6.65957C17.1376 4.99942 15.9692 4.09717 14.4468 4.09717C13.1487 4.09717 12.1692 4.69867 11.6499 5.50469C11.8623 6.03401 12.2046 6.41897 12.8064 6.59942C13.2313 6.1904 13.7152 5.81747 14.3878 5.81747C14.9661 5.81747 15.2965 6.15431 15.2965 6.70769C15.2965 7.32123 14.9661 7.76634 12.2872 10.3167C11.9213 10.6776 11.7561 11.1107 11.7561 11.5077C11.7561 11.7242 11.7915 11.9287 11.8387 12.0972H17.3854C17.4444 11.9167 17.5034 11.5919 17.5034 11.2671C17.5034 10.9904 17.4562 10.6776 17.3854 10.4731Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_300_1668">
        <rect width="18" height="12" fill="white" transform="translate(0 0.150635)" />
      </clipPath>
    </defs>
  </svg>
));

export default H2;
